import { render, staticRenderFns } from "./ModuleTransferHistory.vue?vue&type=template&id=380a300b&scoped=true&"
import script from "./ModuleTransferHistory.vue?vue&type=script&lang=js&"
export * from "./ModuleTransferHistory.vue?vue&type=script&lang=js&"
import style0 from "./ModuleTransferHistory.vue?vue&type=style&index=0&id=380a300b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380a300b",
  null
  
)

export default component.exports